import type { ReactNode } from "react";
import getClasses from "utils/getClasses";
import styles from "./TimeslotTitle.module.css";

type Props = {
  children: ReactNode;
  className?: string;
};

const TimeslotTitle = ({ children, className }: Props) => (
  <span className={getClasses(styles["timeslot-title"], className)}>
    {children}
  </span>
);

export default TimeslotTitle;
